<mat-dialog-content>
  <div class="container mt-2">
    <div class="row justify-content-between m-3">
      <div class="col-xl-12 col-lg-12 col-md-12 col-xs-12 align-self-center">
        <div class="row justify-content-center">
          <mat-label>
            <span color="primary">
              Estás modificando tu usuario a una cuenta comercio, tené en cuenta que tu alias y CVU van a cambiar.
              <br />
              En la sección "mi comercio" podés asesorarte de las comisiones por cada cobro.
            </span>
          </mat-label>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center" class="mb-2">
  <div class="row m-none align-items-center m-0">
    <button mat-raised-button mat-dialog-close color="clear" class="mr-2 w-button button-actions">
      {{ 'dialog_confirm.buttons.cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" class="w-button mr-2 button-actions font-clear" (click)="resDialog()">
      Crear mi cuenta comercio
    </button>
  </div>
</mat-dialog-actions>
